import create from "zustand";
import { subscribeWithSelector, shallow } from "zustand/middleware";

export const userStore = create(
  subscribeWithSelector((set) => ({
    user: JSON.parse(localStorage.getItem("user")),
    setUser: (user) => set(() => ({ user: user })),
    isAuthenticated: localStorage.getItem("user") != null,
    setIsAuthenticated: (isAuthenticated) =>
      set(() => ({ isAuthenticated: isAuthenticated })),
  }))
);

export const projectStore = create(
  subscribeWithSelector((set) => ({
    project: null,
    setProject: (project) => set(() => ({ project: project })),
  }))
);

export const generalStore = create(
  subscribeWithSelector((set) => ({
    hideLoading: true,
    setHideLoading: (hideLoading) => set(() => ({ hideLoading: hideLoading })),
    isLoading: false,
    setIsLoading: (isLoading) => set(() => ({ isLoading: isLoading })),
    refreshTokenTimeout: null,
    setRefreshTokenTimeout: (refreshTokenTimeout) => () => ({
      refreshTokenTimeout: refreshTokenTimeout,
    }),
  }))
);

export const selectionStore = create(
  subscribeWithSelector((set) => ({
    selectedUnitGuid: null,
    setSelectedUnitGuid: (value) =>
      set(() => ({ selectedUnitGuid: value })),
  }))
);
export const navigationStore = create(
  subscribeWithSelector((set) => ({
    navigations: null,
    setNavigations: (value) =>
      set(() => ({ navigations: value })),
  }))
);
